export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "Collection Bin Management": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回収ボックスの管理"])},
      "Create Bin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回収ボックスコードを作成する"])},
      "Created at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["作成日"])},
      "Bin Name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回収ボックス名"])}
    }
  })
}
